import { render, staticRenderFns } from "./BoxProgramStatus.vue?vue&type=template&id=882d4458&scoped=true&"
import script from "./BoxProgramStatus.vue?vue&type=script&lang=ts&"
export * from "./BoxProgramStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BoxProgramStatus.vue?vue&type=style&index=0&id=882d4458&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d4458",
  null
  
)

export default component.exports